var exports = {
  "Lw": "UploadDropModal.module__overlay___MmE2bU",
  "r3": "UploadDropModal.module__dialog___MmE2bU",
  "ew": "UploadDropModal.module__dialogIconCircle___MmE2bU",
  "aY": "UploadDropModal.module__dialogIcon___MmE2bU",
  "tp": "UploadDropModal.module__dialogTextBlock___MmE2bU",
  "nl": "UploadDropModal.module__dialogTitle___MmE2bU",
  "HP": "UploadDropModal.module__dialogDescription___MmE2bU",
  "ly": "UploadDropModal.module__statusBanner___MmE2bU",
  "zm": "UploadDropModal.module__statusBannerActive___MmE2bU",
  "Sl": "UploadDropModal.module__statusBannerDefault___MmE2bU",
  "UX": "UploadDropModal.module__statusIndicator___MmE2bU",
  "Ie": "UploadDropModal.module__statusIndicatorActive___MmE2bU",
  "I8": "UploadDropModal.module__statusIcon___MmE2bU",
};

module.exports = exports;
